/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListWorkloadTokenEndpointsSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type ListWorkloadTokenEndpointsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListWorkloadTokenEndpointsSecurity = {
  option1?: ListWorkloadTokenEndpointsSecurityOption1 | undefined;
  option2?: ListWorkloadTokenEndpointsSecurityOption2 | undefined;
};

export type ListWorkloadTokenEndpointsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListWorkloadTokenEndpointsSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListWorkloadTokenEndpointsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListWorkloadTokenEndpointsSecurityOption1$Outbound,
    ListWorkloadTokenEndpointsSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listWorkloadTokenEndpointsSecurityOption1ToJSON(
  listWorkloadTokenEndpointsSecurityOption1:
    ListWorkloadTokenEndpointsSecurityOption1,
): string {
  return JSON.stringify(
    ListWorkloadTokenEndpointsSecurityOption1$outboundSchema.parse(
      listWorkloadTokenEndpointsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListWorkloadTokenEndpointsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListWorkloadTokenEndpointsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListWorkloadTokenEndpointsSecurityOption2$Outbound,
    ListWorkloadTokenEndpointsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listWorkloadTokenEndpointsSecurityOption2ToJSON(
  listWorkloadTokenEndpointsSecurityOption2:
    ListWorkloadTokenEndpointsSecurityOption2,
): string {
  return JSON.stringify(
    ListWorkloadTokenEndpointsSecurityOption2$outboundSchema.parse(
      listWorkloadTokenEndpointsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListWorkloadTokenEndpointsSecurity$Outbound = {
  Option1?: ListWorkloadTokenEndpointsSecurityOption1$Outbound | undefined;
  Option2?: ListWorkloadTokenEndpointsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListWorkloadTokenEndpointsSecurity$outboundSchema: z.ZodMiniType<
  ListWorkloadTokenEndpointsSecurity$Outbound,
  ListWorkloadTokenEndpointsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListWorkloadTokenEndpointsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListWorkloadTokenEndpointsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listWorkloadTokenEndpointsSecurityToJSON(
  listWorkloadTokenEndpointsSecurity: ListWorkloadTokenEndpointsSecurity,
): string {
  return JSON.stringify(
    ListWorkloadTokenEndpointsSecurity$outboundSchema.parse(
      listWorkloadTokenEndpointsSecurity,
    ),
  );
}

/** @internal */
export type ListWorkloadTokenEndpointsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListWorkloadTokenEndpointsRequest$outboundSchema: z.ZodMiniType<
  ListWorkloadTokenEndpointsRequest$Outbound,
  ListWorkloadTokenEndpointsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listWorkloadTokenEndpointsRequestToJSON(
  listWorkloadTokenEndpointsRequest: ListWorkloadTokenEndpointsRequest,
): string {
  return JSON.stringify(
    ListWorkloadTokenEndpointsRequest$outboundSchema.parse(
      listWorkloadTokenEndpointsRequest,
    ),
  );
}
